import { render } from "./Noticias.vue?vue&type=template&id=61b69298"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"

import "./Noticias.vue?vue&type=style&index=0&id=61b69298&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__